export const path = "/master-cps";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "MASTER CPS",
  section: "ALUNA",
  group: null,
  order: 2,
  roles: [
    "Authenticated",
    "aluna",
    "design",
    "aluna-management",
    "master-aluna-rrss",
    "aluna-afiliado",
  ],
};
